import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from "../api/axios"

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function OficialesFind(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

/*  const [value, setValue] = React.useState(options[props.value]);
  const [inputValue, setInputValue] = React.useState('');*/

  React.useEffect(()=>{
    actEmpresas();
  }, [])

  let actEmpresas = async () => {
    let rows = [{label: '', id: 0}]
    try {
      let respuesta = await axios.post("listas/oficiales", {}, {
        headers: { 'Content-Type': 'application/json' }
      });
      let data = respuesta.data;
      let lista = data.lista || [];
      for (var i = 0; i < lista.length; i++) {
        let item = {
          label: lista[i].nombre,
          id: lista[i].id
        }
        rows.push(item)
      }
    } catch (error) {
      console.log(error)
    }

    setOptions(rows)

  }


  /*React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      let rows = await actEmpresas();
      if (active) {
        setOptions([...rows]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);*/

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={props.value}
      onChange={(event, newValue) => {
        newValue = newValue || { label: "", id: 0 }
        props.handleCambio(newValue)
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.label || ''}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="(Seleccione Oficial)"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
